function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v15H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 1c.557 0 1.06.281 1.338.75l2.468 4.147a.592.592 0 01-.227.822.631.631 0 01-.847-.22L7.763 2.35a.3.3 0 00-.263-.147.3.3 0 00-.263.147L1.284 12.354a.281.281 0 000 .295.299.299 0 00.263.147h11.906a.299.299 0 00.263-.147.281.281 0 000-.295l-2.386-4.01a.592.592 0 01.227-.822.631.631 0 01.848.22l2.386 4.01c.279.468.279 1.03 0 1.499-.279.468-.78.749-1.338.749H1.547c-.557 0-1.06-.281-1.338-.75a1.448 1.448 0 010-1.498L6.162 1.75C6.441 1.281 6.943 1 7.5 1zm0 9.4c.373 0 .676.295.676.657 0 .175-.07.34-.198.464a.685.685 0 01-.478.192.667.667 0 01-.676-.656c0-.362.303-.656.676-.656zm0-4.834c.373 0 .676.294.676.656V8.67a.667.667 0 01-.676.656.667.667 0 01-.676-.656V6.222c0-.362.303-.656.676-.656z",
  fill: "#D24667"
}))));